export const googleAnalyticsEvents = {
    SIGNUP_INITIATED: 'Signup Initiated',
    SIGNUP_COMPLETED: 'Signup Completed',
    LOGIN_SCREEN_VISIT: 'Login Screen Visit',
    PAYMENT_INITIATED: 'Payment Initiated',
    VIEW_REPORT_CLICK: 'View Report Click',
    PAYMENT_COMPLETED: 'Payment Completed',
    CHECK_VIN_CLICK_INVALID: 'Check VIN Click Invalid',
    CHECK_VIN_CLICK_VALID: 'Check VIN Click Valid',
    SELECT_PLAN_CLICK: 'Select Plan Click',
};

